<template>
  <v-list-item-subtitle
    v-if="ilmoitus.type === 'ilmoittautuminen' || ilmoitus.type === 'kokous'"
    class="mt-2 text-wrap"
  >
    <v-divider />
    <div class="mt-4 mb-0">
      <h4 v-if="participants.length === 0" class="mb-6">
        Ei yhtään ilmoittautunutta
        <template v-if="ilmoitus.participantCount > 0"
          >(max {{ ilmoitus.participantCount }})
        </template>
      </h4>
      <h4 v-else>
        Ilmoittautuneet
        <template v-if="ilmoitus.participantCount > 0">
          {{ participants.length }}/{{ ilmoitus.participantCount }}
        </template>
        <v-btn x-small @click="changeOrder" icon>
          <v-icon>mdi mdi-sort</v-icon>
        </v-btn>
      </h4>

      <v-text-field
        v-if="useAdminInterface"
        v-model="newParticipant"
        class="mt-2"
        dense
        label="Ilmoittautuneen nimi"
        outlined
        placeholder="Lisää uusi ilmoittautunut"
      >
        <template v-slot:append-outer>
          <div class="d-flex justify-center mt-n1 ml-n1">
            <v-btn
              :disabled="newParticipant.length <= 3"
              :loading="loadingManualIlmoittautuminen"
              color="primary"
              @click="openInfoDialog(true)"
            >
              <v-icon>mdi mdi-plus</v-icon>
            </v-btn>
          </div>
        </template>
      </v-text-field>

      <ul class="mb-2 mt-2" v-if="participants && participants.length > 0">
        <li v-for="participant in participants" :key="participant.sub">
          <ilmoittautuminen-hallitus-participant
            :ilmoitus="ilmoitus"
            :participant="participant"
            :use-admin-interface="useAdminInterface"
            @deleted="$emit('reload')"
          />
        </li>
      </ul>
      <v-btn
        v-if="!ilmoitus._participant && !isFull"
        :loading="loadingIlmoittautuminen"
        color="primary"
        outlined
        small
        @click="openInfoDialog(false)"
        >Ilmoittaudu
      </v-btn>
      <v-btn
        v-if="ilmoitus._participant"
        :loading="loadingIlmoittautuminen"
        color="error"
        outlined
        small
        @click="deleteIlmoittautuminen"
        >Poista ilmoittautuminen
      </v-btn>
    </div>
    <v-dialog
      persistent
      v-model="infoDialogOpen"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="500"
    >
      <v-card>
        <v-card-title>Ilmoittautumisen lisätiedot</v-card-title>
        <v-divider />
        <v-card-text>
          <v-text-field
            v-model="info"
            autofocus
            class="mt-5"
            label="Mahdolliset lisätiedot"
          ></v-text-field>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="infoDialogOpen = false">Sulje </v-btn>
          <v-btn
            :loading="loadingIlmoittautuminen"
            color="primary"
            outlined
            @click="saveFn"
            >Ilmoittaudu
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item-subtitle>
</template>

<script>
import api from "@/api";
import IlmoittautuminenHallitusParticipant from "@/components/Hallitus/IlmoittautuminenHallitusParticipant.vue";
import { orderBy } from "lodash";

export default {
  name: "IlmoittautuminenHallitus",
  components: { IlmoittautuminenHallitusParticipant },
  data() {
    return {
      loadingIlmoittautuminen: false,
      newParticipant: "",
      loadingManualIlmoittautuminen: false,
      info: "",
      infoDialogOpen: false,
      saveFn: null,
      order: "full_name",
    };
  },
  props: {
    ilmoitus: Object,
    admin: Boolean,
  },
  methods: {
    changeOrder() {
      this.order = this.order === "full_name" ? "created" : "full_name";
    },
    openInfoDialog(manual) {
      this.saveFn = manual
        ? this.addNewIlmoittautuminen
        : this.createIlmoittautuminen;
      this.infoDialogOpen = true;
      this.info = "";
    },

    async addNewIlmoittautuminen() {
      this.loadingManualIlmoittautuminen = true;
      try {
        await api.ilmoitusHallitusIlmoittautuminen({
          ilmoitusId: this.ilmoitus.id,
          manual: true,
          name: this.newParticipant,
          info: this.info,
        });
        this.$toast("Ilmoittautuminen lisätty", { type: "success" });
      } catch (e) {
        console.error(e);
        this.$toast("Ilmoittautuminen ei onnistunut", { type: "error" });
        this.loadingManualIlmoittautuminen = false;
      }
      this.$emit("reload");
      this.loadingManualIlmoittautuminen = false;
    },
    async createIlmoittautuminen() {
      this.loadingIlmoittautuminen = true;
      try {
        await api.ilmoitusHallitusIlmoittautuminen({
          ilmoitusId: this.ilmoitus.id,
          info: this.info,
        });
        this.$toast("Ilmoittautuminen lisätty", { type: "success" });
      } catch (e) {
        console.error(e);
        this.$toast("Ilmoittautuminen ei onnistunut", { type: "error" });
        this.loadingIlmoittautuminen = false;
      }
      this.$emit("reload");
      this.infoDialogOpen = false;
      this.loadingIlmoittautuminen = false;
    },
    async deleteIlmoittautuminen() {
      this.loadingIlmoittautuminen = true;
      try {
        await api.ilmoitusHallitusIlmoittautuminenDelete({
          ilmoitusId: this.ilmoitus.id,
        });
        this.$toast("Ilmoittautuminen poistettu", { type: "success" });
      } catch (e) {
        console.error(e);
        this.$toast("Ilmoittautumisen poistaminen ei onnistunut", {
          type: "error",
        });
        this.loadingIlmoittautuminen = false;
      }

      this.$emit("reload");
      this.loadingIlmoittautuminen = false;
      //this.loadingIlmoittautuminen = false;
    },
  },
  computed: {
    participants() {
      return orderBy(this.ilmoitus.participants || [], [this.order], ["asc"]);
    },
    useAdminInterface() {
      return this.admin && this.$isAdmin;
    },
    max() {
      return this.ilmoitus.participantCount || 0;
    },
    isFull() {
      return this.max > 0 && this.participants.length >= this.max;
    },
  },
};
</script>

<style scoped></style>
